import React, { useEffect, useState } from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import { createStowagePlanChange } from 'src/factory/Stowage/StowagePlanChanges/StowagePlanChangeFactory';
import { StowageChangeDataType } from 'src/types/ViewModel/Stowage/Enums/StowageChangeDataType';
import usePostStowageApi from 'src/api/stowage/usePostStowageApi';
import { cargoColors, getColorIndex } from 'src/utils/stowage/cargoColorsUtils';
import OdfjellPanel, { PANEL_CONSTANTS } from 'src/components/ui/odfjellPanel/OdfjellPanel';
import { PanelSectionContent, ElementWrapper, ColorList } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import { DefaultFlexStrechedWrapper } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import { StowagePlanChange } from 'src/types/ViewModel/Stowage/StowagePlanChange';
import { getEnvironment } from 'src/utils/environmentUtils';
import { ColorListItem } from './CargoColorPanel.styles';
import { getFormattedCargoNumber, isManualCargo } from 'src/utils/stowage/cargoOperationUtils';

const CargoColorPanel: React.FC = () => {
    const { activeStowagePlan, setIsCargoColorPanelOpen } = useStowageStore();
    const { selectedCargoOperation } = useStowageSelectionStore();
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const { saveStowageData } = usePostStowageApi();
    const environment = getEnvironment();

    useEffect(() => {
        if (!activeStowagePlan || !selectedCargoOperation) {
            return;
        }

        setSelectedIndex(selectedCargoOperation.cargo.colorId ?? getColorIndex(selectedCargoOperation.cargoGuid));
    }, []);

    const isFormDataInvalid = (): boolean => {
        return false;
    };

    const onSelectCargoColor = async (colorIndex: number) => {
        if (!selectedCargoOperation) return;
        const stowagePlanChanges: StowagePlanChange[] = [
            createStowagePlanChange(activeStowagePlan.stowagePlanGuid, selectedCargoOperation.cargo.cargoGuid, StowageChangeDataType.RotationCargo, {
                colorId: colorIndex,
            }),
        ];

        setSelectedIndex(colorIndex);
        await saveStowageData(activeStowagePlan, stowagePlanChanges);
    };

    const onClosePanel = () => {
        setIsCargoColorPanelOpen(false);
    };

    return (
        <OdfjellPanel
            headerTitle={'Select new cargo color'}
            extHeaderTitle={getFormattedCargoNumber(
                selectedCargoOperation.cargo.voyageNumber,
                selectedCargoOperation.cargo.cargoNumber,
                isManualCargo(selectedCargoOperation.cargo)
            )}
            defaultPosition="center"
            preventOutsideClose={true}
            onCancel={onClosePanel}
            actionButtonText="Close"
            onAction={onClosePanel}
            isActionDisabled={isFormDataInvalid()}
            panelWidth={PANEL_CONSTANTS.MEDIUM_WIDTH}
        >
            <DefaultFlexStrechedWrapper>
                <PanelSectionContent>
                    <ElementWrapper>
                        <ColorList>
                            {cargoColors.map((color, index) => {
                                return (
                                    <ColorListItem
                                        className={index === selectedIndex ? 'selected' : ''}
                                        onClick={() => onSelectCargoColor(index)}
                                        key={'color_' + index}
                                        backgroundColor={color}
                                    >
                                        {environment === 'localhost' || environment === 'dev' ? cargoColors[index] : ''}
                                    </ColorListItem>
                                );
                            })}
                        </ColorList>
                    </ElementWrapper>
                </PanelSectionContent>
            </DefaultFlexStrechedWrapper>
        </OdfjellPanel>
    );
};

export default CargoColorPanel;
